import React from 'react'
import PaginatedList from './paginated-list'
import { useSelector } from 'react-redux'

const ListView = ({uniform, stateKey = 'programs', defaultItems}) => {
  const defaultPrograms = useSelector(state => state[stateKey].data)
  const programs = defaultItems ? defaultItems : defaultPrograms
  const query = useSelector(state => state[stateKey].query)

  return (
    <PaginatedList
      query={query}
      defaultData={programs}
    />
  )
}

export { ListView }
